import { graphql } from '../gql';

export const GET_GENERAL_INFORMATION_FORM_FOR_BUSINESS = graphql(`
  query getGeneralInformationFormForBusiness($businessId: ID) {
    getGeneralInformationFormForBusiness(businessId: $businessId) {
      ...FinalFormFields
    }
  }
`);
